/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from "react";
import { logger } from "../../../utils/logger";
import { SALARY_DETAILS_CONST } from "./pay-kyc-const";
import { SALARY_DETAILS_SCHEMA } from "./Pay-kyc-validation";
import useAPIHandler from "../../../hook/use-api-handler";
import { useParams } from "react-router-dom";
import { useToast } from "../../../context/toast-context";

const PayKycService = () => {
  const { fetchData } = useAPIHandler();
  const { showToastMessage } = useToast();
  const fileInputRef = useRef(null);
  const { id } = useParams();
  const [paymentData, setPaymentData] = useState({
    salary_type: "fixed",
    payment_mode: "",
    ammount: "",
    payment_by: "",
  });
  const [alldocs, setAlldocs] = useState([]);
  const [kycDoc, setKycDoc] = useState({});
  const [paymentErr, setPaymentErr] = useState({});

  //modal
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentloader, setPaymentLoader] = useState(false);
  const [kycMOdal,setKycModal]=useState(false)

  const PaymentModalToggle = () => {
    setPaymentModal(!paymentModal);
  };
  const kycModalToggle=()=>{
    setKycModal(!kycMOdal)
  }

  const onChangePayment = (e, name) => {
    let value = e;
    if (e && e.target) {
      value = e.target.value;
    }
    if (SALARY_DETAILS_CONST[name]?.customOptions) {
      value = SALARY_DETAILS_CONST[name]?.customOptions?.formatValueFn(
        value,
        paymentData
      );
    }

    const updatedPaymentData = {
      ...paymentData,
      [name]: value,
    };

    // Remove specific fields if salary_type is "fixed"
    if (name === "salary_type" && value === "fixed") {
      const fieldsToRemove = [
        "wages_type",
        "wages_rate",
        "wages_payment_mode",
        "wages_days",
      ];
      fieldsToRemove.forEach((field) => {
        delete updatedPaymentData[field];
      });
    }

    setPaymentData(updatedPaymentData);

    const schema = SALARY_DETAILS_SCHEMA;

    const { error } = schema.validate(updatedPaymentData, {
      context: {
        salary_type: updatedPaymentData?.salary_type,
        amount: updatedPaymentData?.amount,
        payment_mode: updatedPaymentData?.payment_mode,
        wages_payment_mode: updatedPaymentData?.wages_payment_mode,
      },
      abortEarly: false,
    });

    if (!error) {
      setPaymentErr((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    } else {
      const fieldError = error.details.find((err) => err.path[0] === name);
      setPaymentErr((prevErrors) => ({
        ...prevErrors,
        [name]: fieldError ? fieldError.message : undefined,
      }));
    }
  };
  const OnBlurePayment = (e, name) => {
    const { value } = e.target;
    const updatedPaymentDate = {
      ...paymentData,
      [name]: value,
    };
    const { error } = SALARY_DETAILS_SCHEMA.validate(updatedPaymentDate, {
      context: {
        salary_type: updatedPaymentDate?.salary_type,
        amount: updatedPaymentDate?.amount,
        payment_mode: updatedPaymentDate?.payment_mode,
        wages_payment_mode: updatedPaymentDate?.wages_payment_mode,
      },
      abortEarly: false,
    });

    if (error) {
      const fieldError = error.details.find((err) => err.path[0] === name);
      if (fieldError) {
        setPaymentErr((prevErrors) => ({
          ...prevErrors,
          [name]: fieldError.message,
        }));
      } else {
        setPaymentErr((prevErrors) => {
          const { [name]: removedError, ...restErrors } = prevErrors;
          return restErrors;
        });
      }
    } else {
      setPaymentErr((prevErrors) => {
        const { [name]: removedError, ...restErrors } = prevErrors;
        return restErrors;
      });
    }
  };
  function EmployeePayKycInfo() {
    const URL = `employee/pay-kyc/${id}`;
    const METHOD = "GET";
    const payload = {
      url: URL,
      METHOD,
    };
    try {
      fetchData(payload)
        .then((res) => {
          const resData = res?.data || {};
          setPaymentData(resData);
         setAlldocs(resData?.kyc_additional_info)
        })
        .catch((err) => {
          logger.log(err);
        });
    } catch (error) {
      logger.log(error);
    }
  }
  //   error function
  const validatePaymentData = () => {
    const { error } = SALARY_DETAILS_SCHEMA.validate(paymentData, {
      context: {
        salary_type: paymentData?.salary_type,
        amount: paymentData?.amount,
        payment_mode: paymentData?.payment_mode,
        wages_payment_mode: paymentData?.wages_payment_mode,
      },
      abortEarly: false,
    });
  
  
    if (error) {
      const newErrors = {};
      error.details.forEach((err) => {
        newErrors[err.path[0]] = err.message;
      });
      setPaymentErr(newErrors);
      return false;
    }
    setPaymentErr({});

    return true;
  };
  // get info
  useEffect(() => {
    EmployeePayKycInfo();
  }, []);

  useEffect(() => {
    if (
      kycDoc?.document_type &&
      kycDoc?.document_number &&
      kycDoc?.attachment
    ) {
      const temp = [...alldocs, kycDoc];
      setAlldocs(temp);
      setKycDoc({});
    }
  }, [
    kycDoc?.document_type,
    kycDoc?.document_number,
    kycDoc?.attachment,
    alldocs,
    kycDoc,
  ]);

  // submit

  const onSubmitPayKyc = async () => {
    if (validatePaymentData()) {
      const values = { ...paymentData, kyc_additional_info: alldocs };
      const formData = new FormData();
      for (const key in values) {
        if (key === "kyc_additional_info") {
          values[key].forEach((doc, index) => {
            for (const docKey in doc) {
              if (doc[docKey] !== "") {
                formData.append(
                  `kyc_additional_info[${index}][${docKey}]`,
                  doc[docKey]
                );
              }
            }
          });
        } else if (values[key] !== "") {
          formData.append(key, values[key]);
        }
      }
      try {
        const res = await fetchData({
          data: formData,
          url: `employee/pay-kyc/${id}`,
          method: "POST",
        });
      } catch (error) {
        showToastMessage({
          message: "Something went wrong!",
          color: "danger",
        });
      }
    }
  };

  const onUpdatePayKyc = async () => {
  
    if (validatePaymentData()) {
      setPaymentLoader(true);
      const values = { ...paymentData, kyc_additional_info: alldocs };
      const formData = new FormData();
      for (const key in values) {
        if (key === "kyc_additional_info") {
          values[key].forEach((doc, index) => {
            for (const docKey in doc) {
              if (doc[docKey] !== "") {
                formData.append(
                  `kyc_additional_info[${index}][${docKey}]`,
                  doc[docKey]
                );
              }
            }
          });
        } else if (values[key] !== "") {
          formData.append(key, values[key]);
        }
      }
      try {
        const res = await fetchData({
          data: formData,
          url: `employee/pay-kyc/${id}/update/${paymentData?.employee_pay_and_kyc_id}`,
          method: "POST",
        });
        if (res) {
          showToastMessage({
            message: "Pay and Kyc updated!",
            color: "success",
          });
          setPaymentLoader(false);
         setPaymentModal(false);
       
         setKycModal(false)
         
        }
      } catch (error) {
  
        setPaymentLoader(false);
        setPaymentModal(false);
       
        setKycModal(false)
        showToastMessage({
          message: "Something went wrong!",
          color: "danger",
        });
      }
    }
  };

  const checkDocName = (val) => {
    const temp = alldocs.map((item) => item.document_type);
    return temp.includes(val);
  };
  const onChangeKYCdoc = (e, name, type) => {
    let value = e;
    if (e && e.target) {
      value = e.target.value;
    }
    if (type === "file") {
      value = e.target.files[0];
    }
    setKycDoc({
      ...kycDoc,
      [name]: value,
    });
  };
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setKycDoc({ ...kycDoc, ["attachment"]: selectedFile });
    }
  };

  //delete file from particuler index
  const DeleteSpecificFile = (pos) => {
    const temp = alldocs?.filter((index, id) => {
      if (id !== pos) {
        return index;
      }
    });
    setAlldocs(temp);
  };

  //open file in a newTab
  function openFileInNewTab(file) {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, "_blank");
  }

  return {
    paymentData,
    onChangePayment,
    OnBlurePayment,
    paymentErr,
    onSubmitPayKyc,
    onChangeKYCdoc,
    alldocs,
    kycDoc,
    fileInputRef,
    handleButtonClick,
    handleFileChange,
    DeleteSpecificFile,
    openFileInNewTab,
    checkDocName,
    paymentModal,
    PaymentModalToggle,
    onUpdatePayKyc,
    paymentloader,
    kycModalToggle,
    kycMOdal
  };
};

export default PayKycService;
